/* enum Status {
    'pending',
    'fulfilled',
    'rejected',
}
type Result = {
    status: Status;
    data: any;
    err: any;
};

let myFetch: any = () => {
    return new Promise<any>((resolve, reject) => {
        const xmlHttp = new XMLHttpRequest();
        xmlHttp.open('HEAD', location.href.split('#')[0] + '?t=' + Date.now(), true);
        xmlHttp.send();
        xmlHttp.onerror = reject;
        xmlHttp.onload = () => {
            const headerDate = xmlHttp.getResponseHeader('Date')!;
            serverTime = new Date(headerDate);
            resolve(serverTime);
        };
    });
};

const _myFetch = myFetch;
const run = (func: (...args: any[]) => any) => {
    let cache: Result[] = [];
    let i = 0;
    myFetch = () => {
        const item = cache[i];
        if (item) {
            if (item.status === Status.fulfilled) {
                return item.data;
            } else if (item.status === Status.rejected) {
                throw item.err;
            }
        }
        const result: Result = {
            status: Status.pending,
            data: null,
            err: null,
        };
        cache[i++] = result;
        const p = _myFetch().then(
            (resp) => {
                console.log('ppp resp', resp);
                result.status = Status.fulfilled;
                result.data = resp;
            },
            (err) => {
                console.log('ppp err', err);
                result.status = Status.rejected;
                result.err = err;
            },
        );

        throw p;
    };

    try {
        func();
    } catch (err) {
        if (err instanceof Promise) {
            const reRun = () => {
                i = 0;
                func();
            };
            err.then(reRun, reRun);
        }
    }
};

let serverTime: Date | null = null;
let timer: NodeJS.Timeout | null = null;
let startTime: null | number = null;
const getServerTime = () => {
    console.log('🚀 ~ getServerTime ~ serverTime:', 897897);
    if (!(serverTime instanceof Date)) {
        
    }
    serverTime = myFetch();
    console.log('🚀 ~ getServerTime ~ serverTime:', serverTime);
    const ret = new Date(Date.now() - startTime! + serverTime!.getTime());
    console.log('-----*******> ', ret.getTime());
    return ret;
};
// getServerTime()
run(getServerTime);

export default () => {}; */

import getTime from './time';

/* 
let serverTime: Date | null = null;
let timer: NodeJS.Timeout | null = null;
let startTime: null | number = null;
const getServerTime = () => {
    if (!serverTime) {
        startTime = Date.now();
        const xmlHttp = new XMLHttpRequest();
        xmlHttp.open('HEAD', location.href, false);
        xmlHttp.send();
        const headerDate = xmlHttp.getResponseHeader('Date')!;
        serverTime = new Date(headerDate);
        console.log("🚀 ~ getServerTime ~ serverTime:", serverTime)
        // 3分钟后重新获取服务器时间
        timer = setTimeout(() => {
            serverTime = null;
            timer = null;
            startTime = null;
        }, 1000 * 60 * 3);
    }
    const ret = new Date(Date.now() - startTime! + serverTime!.getTime());
    console.log('-----*******> ', ret.getTime());
    return ret;
};

export default getServerTime;
 */

let serverTime: number = Date.now();
let startTime: number = Date.now();
const init = () => {
    startTime = Date.now();
    const xmlHttp = new XMLHttpRequest();
    xmlHttp.open('HEAD', location.href.split('#')[0] + '?t=' + startTime, true);
    xmlHttp.send();
    xmlHttp.onload = () => {
        const headerDate = xmlHttp.getResponseHeader('Date')!;
        if (headerDate) {
            serverTime = new Date(headerDate).getTime();
        } else {
            serverTime = getTime();
        }
    };
};
init();
// 15秒获取一次服务器时间
setInterval(init, 15000);
export default () => {
    const ret = new Date(Date.now() - startTime + serverTime);
    return ret;
};
